export const normalizeOption = ({ value, key, id, ...rest }) => ({ ...rest, label: value, value: key || id });
export const normalizeOptions = (array) => array.map(normalizeOption);